import "react-phone-input-2/lib/style.css";
import classNames from "classnames";
import { useField } from "formik";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";

const inputStyles = classNames(
  "bg-transparent",
  "rounded-md",
  "border",
  "py-2",
  "transition",
  "transition-all",
  "duration-500",
  "appearance-none",
  "!w-full",
  "bg-opacity-10",
  "px-4",
  "leading-tight",
  "outline-none",
  "focus:bg-opacity-30",
  "!h-12",
  "!text-base"
);

const SUPPORTED_COUNTRIES = ["co"];

type Props = {
  name: string;
  label: string;
  labeled: boolean;
  disabled?: boolean;
};

const PhoneNumberField = (props: Props) => {
  const [field, meta, helper] = useField(props);
  const { value, ...rest } = field;
  const { touched, error } = meta;
  const { setValue, setTouched } = helper;
  const [countryWarning, setCountryWarning] = useState(false);
  const [focused, setFocused] = useState(false);

  const handleChange = (
    value: string,
    country: { countryCode: string; dialCode: any },
    e: any
  ) => {
    const parentElementClassName = e.target?.parentElement?.className;
    const isCountrySelected =
      parentElementClassName === "country" ||
      parentElementClassName === " country-list";
    const isUnsupportedCountry =
      SUPPORTED_COUNTRIES.indexOf(country?.countryCode) === -1;
    if (isCountrySelected && isUnsupportedCountry) {
      setCountryWarning(true);
    }

    setValue({
      number: value,
      countryCode: country.countryCode,
      countryDialCode: country.dialCode,
    });
  };

  const handleBlur = () => {
    setTouched(true);
    setFocused(false);
  };

  const handleFocus = () => {
    setFocused(true);
  };

  function _renderHelperText() {
    if (touched && !!error?.length) {
      return (
        <div className="text-red-700 absolute bottom-1 text-sm">{error}</div>
      );
    }
  }

  return (
    <div className="relative flex flex-col gap-1 pb-6 w-full">
      {props.labeled ? (
        <label
          className={classNames(
            "absolute",
            "-top-3",
            "left-4",
            "bg-white",
            "px-1",
            "text-philippine-silver",
            "z-10",
            "text-sm",
            {
              "text-copper": focused,
              "text-philippine-silver": !focused && !meta.error,
              "text-red-700": meta.error && meta.touched,
            }
          )}
        >
          {props.label}
        </label>
      ) : null}
      <PhoneInput
        {...rest}
        country="co"
        value={value?.number}
        countryCodeEditable={false}
        placeholder="+57 (302) 123 4567"
        inputClass={classNames(inputStyles, {
          "!border-red-700": meta.error && meta.touched,
          "!border-philippine-silver": !meta.error && !focused,
          "!border-copper": focused,
        })}
        buttonClass={classNames("!bg-white", {
          "!border-red-700": meta.error && meta.touched,
          "!border-philippine-silver": !meta.error && !focused,
          "!border-copper": focused,
        })}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        disabled={props.disabled}
      />
      {_renderHelperText()}
    </div>
  );
};

export default PhoneNumberField;
